import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import HeaderBar from './HeaderBar';
import TopNavBar from './TopNavBar';
import { motion } from 'framer-motion';

const SiteLayout = ({ children }) => {
  const location = useLocation();
  const { siteName: siteParam, selectedDate: dateParam } = useParams();

  useEffect(() => {
    if (siteParam) sessionStorage.setItem('siteName', siteParam);
    if (dateParam) sessionStorage.setItem('selectedDate', dateParam);
  }, [siteParam, dateParam]);

  const siteName = siteParam || sessionStorage.getItem('siteName') || '';
  const selectedDate = dateParam || sessionStorage.getItem('selectedDate') || '';

  console.log('SiteLayout.js → siteName:', siteName);
  console.log('SiteLayout.js → selectedDate:', selectedDate);

  return (
    <>
      <HeaderBar siteName={siteName} selectedDate={selectedDate} />
      <TopNavBar siteName={siteName} selectedDate={selectedDate} />
      <motion.div
        className="site-content-area"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
      >
        {children}
      </motion.div>
    </>
  );
};

export default SiteLayout;
